import { NgModule } from '@angular/core'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { ContactUsComponent } from './contact-us.component'
import { CommonModule } from '@angular/common'
import { FormErrorsModule } from '@spartacus/storefront'
import { MaterialModule } from '../shared/material.module'
import { NgxCaptchaModule } from 'ngx-captcha'
import { ReactiveFormsModule } from '@angular/forms'

@NgModule({
  declarations: [ContactUsComponent],
  imports: [CommonModule, I18nModule, FormErrorsModule, MaterialModule, NgxCaptchaModule, ReactiveFormsModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ContactUsComponent: {
          component: ContactUsComponent
        }
      }
    })
  ],
  exports: [ContactUsComponent]
})
export class ContactUsModule {}
